let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("e9Lfg"), load("7xv66"), load("hXJOj")]).then(() => parcelRequire('f53HT'));